<template>
    <div class="notification">
        <ValidationObserver class="notification__form" ref="form" v-slot="{handleSubmit}">
            <vs-row vs-type="flex">
                <vs-col
                    vs-xs="12"
                    vs-sm="12"
                    vs-w="12"
                    vs-lg="12"
                >
                    <vs-checkbox v-model="fields.isSendToAllChannels">{{$t('notifications.send_to_all_channels')}}</vs-checkbox>
                </vs-col>
            </vs-row>

            <vs-row vs-type="flex" class="mt-4" v-if="!fields.isSendToAllChannels">
                <vs-col
                    vs-xs="12"
                    vs-sm="6"
                    vs-w="4"
                    vs-lg="3"
                >
                    <ValidationProvider
                        vid="channelIds"
                        :name="$t('notifications.channels')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <label class="text-sm opacity-75">{{ $t('notifications.channels') }}</label>

                        <v-select
                            class="mt-1"
                            v-model="fields.channelIds"
                            :options="channelsList"
                            :placeholder="$t('notifications.channels')"
                            :clearable="true"
                            :closeOnSelect="false"
                            :reduce="a => a.id"
                            label="name"
                            value="id"
                            multiple
                        />

                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs mt-1">{{ error }}</p>
                    </ValidationProvider>
                </vs-col>
            </vs-row>

            <vs-row vs-type="flex" class="mt-4">
                <vs-col
                    vs-xs="12"
                    vs-sm="12"
                    vs-w="12"
                    vs-lg="6"
                >
                    <ValidationProvider
                        vid="message"
                        :name="$t('global.message')"
                        rules="required" v-slot="{ errors }"
                    >
                        <label class="text-sm opacity-75">{{ $t('global.message') }}</label>

                        <vs-textarea
                            v-model="fields.message"
                            class="w-full mt-1"
                            height="200px"
                        />

                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                    </ValidationProvider>
                </vs-col>
            </vs-row>

            <vs-row vs-type="flex" class="mt-4">
                <vs-col
                    vs-w="12"
                    vs-sm="12"
                    vs-lg="12"
                    vs-xs="12"
                >
                    <vs-button
                        @click="handleSubmit(submit)"
                        color="primary"
                        type="filled"
                    >{{ $t('buttons.Submit') }}
                    </vs-button>
                </vs-col>
            </vs-row>
        </ValidationObserver>
    </div>
</template>

<script>
import send from "@/utils/fetch";
import ErrorHandler from "@/utils/errorHandler";
import vSelect from "vue-select"

export default {
    components: {
        vSelect,
    },
    data() {
        return {
            fields: {
                isSendToAllChannels: false,
                channelIds: [],
                message: ''
            },
            channelsList: []
        }
    },
    async mounted() {
        await this.loadChannelsList()
    },
    methods: {
        async loadChannelsList() {
            try {
                this.channelsList = await send(this.$url.notifications.getAffiliateBotChannels, 'GET')
                    .then(response => response.data.result.map(item => {
                        return {
                            id: item.id,
                            name: item.hasOwnProperty('title') ? item.title : item.id
                        }
                    }))
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async sendNotification() {
            try {
                await send(this.$url.notifications.sendAffiliateBotNotifications, 'POST', {
                    data: {
                        ids: this.fields.isSendToAllChannels ? this.channelsList.map(item => item.id) : this.fields.channelIds,
                        message: this.fields.message
                    }
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async submit() {
            this.sendNotification()
        }
    }
}
</script>

<style lang="scss" scoped>
.notification {
    background: white;
    padding: 20px;
}
</style>
